export const ErrorText = {
  field:'Required field',
  emailValid:'Not valid email',
  passwordValid:'Not valid password',
  phone: 'Phone Number must be a valid phone number',
  user: 'User already exist',
  backPhoneError: 'phone must be a valid phone number'
}